//Component
import AppDispatcher from '../core/AppDispatcher.jsx';
//Constants
import AppConstants from '../constants/ApplicationConstants.js';
//Utilities
import { EventEmitter } from 'events';

//local variables
const CHANGE_EVENT = 'change',
    ActionTypes = AppConstants.ActionTypes;

let _model = {
    isWithSpecialRequests: 'N',
    specialRequestsDetails: ''
};

function updateSpecialRequestsModel(fieldId, value) {
    _model[fieldId] = (value);
}

function retrieveSpecialRequests(form) {
    if (form.specialRequests) {
        _model = _.cloneDeep(form.specialRequests);
    }
}

class SpecialRequestsStoreClass extends EventEmitter {

    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getSpecialRequestsModel() {
        return _model;
    }
}

const SpecialRequestsStore = new SpecialRequestsStoreClass();

SpecialRequestsStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.UPDATE_SPECIAL_REQUESTS:
            updateSpecialRequestsModel(action.fieldId, action.value);
            break;
        case ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveSpecialRequests(action.applicationData.form);
            break;
        default:
            return true;
    }

    SpecialRequestsStore.emitChange();
    return true;
});

export default SpecialRequestsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/SpecialRequestsStore.js